import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-cf5c755e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "checkbox" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "active" }, "Active", -1))
const _hoisted_3 = { class: "checkbox" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "inactive" }, "Inactive", -1))
const _hoisted_5 = { class: "checkbox" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "favorite" }, "Favorite", -1))
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" Unknown error while saving the patient. Please contact system administration ")
const _hoisted_8 = ["onClick"]
const _hoisted_9 = ["title"]
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Checkbox = _resolveComponent("Checkbox")!
  const _component_LineMenu = _resolveComponent("LineMenu")!
  const _component_Message = _resolveComponent("Message")!
  const _component_Column = _resolveComponent("Column")!
  const _component_MultiSelect = _resolveComponent("MultiSelect")!
  const _component_InlineMessage = _resolveComponent("InlineMessage")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_TabPanel = _resolveComponent("TabPanel")!
  const _component_TabView = _resolveComponent("TabView")!
  const _component_ViewTemplate = _resolveComponent("ViewTemplate")!

  return (_openBlock(), _createBlock(_component_ViewTemplate, { title: "Patient" }, {
    default: _withCtx(() => [
      _createVNode(_component_LineMenu, null, {
        default: _withCtx(() => [
          _createVNode(_component_Button, {
            label: "Add Patient",
            class: "p-mr-2 p-button-raised p-button-rounded",
            onClick: _ctx.addPatient
          }, null, 8, ["onClick"]),
          _createVNode(_component_Dropdown, {
            modelValue: _ctx.searchDropdownValue,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchDropdownValue) = $event)),
            optionLabel: "name",
            optionValue: "code",
            options: _ctx.searchDropdown
          }, null, 8, ["modelValue", "options"]),
          _createVNode(_component_InputText, {
            modelValue: _ctx.searchText,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.searchText) = $event)),
            type: "text"
          }, null, 8, ["modelValue"]),
          _createVNode(_component_Button, {
            label: "Search",
            icon: "pi pi-search",
            class: "p-button-success",
            onClick: _ctx.search
          }, null, 8, ["onClick"]),
          _createElementVNode("span", _hoisted_1, [
            _createVNode(_component_Checkbox, {
              id: "active",
              modelValue: _ctx.activeFilter,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.activeFilter) = $event)),
              binary: true,
              onChange: _ctx.search
            }, null, 8, ["modelValue", "onChange"]),
            _hoisted_2
          ]),
          _createElementVNode("span", _hoisted_3, [
            _createVNode(_component_Checkbox, {
              id: "inactive",
              modelValue: _ctx.inactiveFilter,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.inactiveFilter) = $event)),
              binary: true,
              onChange: _ctx.search
            }, null, 8, ["modelValue", "onChange"]),
            _hoisted_4
          ]),
          _createElementVNode("span", _hoisted_5, [
            _createVNode(_component_Checkbox, {
              id: "favorite",
              modelValue: _ctx.favoriteFilter,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.favoriteFilter) = $event)),
              binary: true,
              onChange: _ctx.search
            }, null, 8, ["modelValue", "onChange"]),
            _hoisted_6
          ])
        ]),
        _: 1
      }),
      (_ctx.errorWhilePosting)
        ? (_openBlock(), _createBlock(_component_Message, {
            key: 0,
            severity: "error"
          }, {
            default: _withCtx(() => [
              _hoisted_7
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      _createVNode(_component_TabView, { class: "p-mb-3" }, {
        default: _withCtx(() => [
          _createVNode(_component_TabPanel, { header: "Patient" }, {
            default: _withCtx(() => [
              _createVNode(_component_DataTable, {
                id: "tablePatient",
                class: "p-datatable-striped p-datatable-sm",
                value: _ctx.patients,
                lazy: true,
                totalRecords: _ctx.patientsCount,
                paginator: true,
                rows: _ctx.rows,
                rowsPerPageOptions: _ctx.ROWS_OPTIONS,
                paginatorTemplate: "FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown",
                sortMode: "multiple",
                removableSort: "",
                dataKey: "id",
                filters: _ctx.filters,
                "onUpdate:filters": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.filters) = $event)),
                filterDisplay: "row",
                onPage: _ctx.pageEvent,
                onSort: _ctx.sortEvent,
                onFilter: _ctx.search,
                rowClass: _ctx.getNewsRowsStyle,
                autoLayout: ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_Column, {
                    field: "favorite",
                    header: "Favorite"
                  }, {
                    body: _withCtx((slotProps) => [
                      _createElementVNode("i", {
                        class: _normalizeClass(["pi", 
                  slotProps.data.favorite ? 'pi-star-fill' : 'pi-star'
                ]),
                        style: {"color":"orange","font-size":"1.5rem"},
                        onClick: () => _ctx.toggleFavorite(slotProps.data)
                      }, null, 10, _hoisted_8)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_Column, {
                    field: "patientid",
                    header: "Patient Id",
                    sortable: true
                  }),
                  _createVNode(_component_Column, {
                    field: "patientid1",
                    header: "T-number",
                    sortable: true
                  }),
                  _createVNode(_component_Column, {
                    field: "patcenter",
                    header: "TC"
                  }),
                  _createVNode(_component_Column, {
                    field: "lastname",
                    header: "Last Name",
                    sortable: true
                  }),
                  _createVNode(_component_Column, {
                    field: "firstname",
                    header: "First Name",
                    sortable: true
                  }),
                  _createVNode(_component_Column, {
                    field: "birthdate",
                    header: "Date of Birth",
                    sortable: true
                  }, {
                    body: _withCtx((slotProps) => [
                      _createTextVNode(_toDisplayString(_ctx.formatDate(slotProps.data.birthdate)), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_Column, {
                    field: "gender",
                    header: "Gender",
                    showFilterMenu: false
                  }, {
                    filter: _withCtx(({ filterModel, filterCallback }) => [
                      _createVNode(_component_MultiSelect, {
                        modelValue: filterModel.value,
                        "onUpdate:modelValue": ($event: any) => ((filterModel.value) = $event),
                        onChange: ($event: any) => (filterCallback()),
                        options: _ctx.Gender.values.filter((g) => g.code != 2),
                        optionLabel: "name",
                        optionValue: "code",
                        placeholder: "Any",
                        class: "p-column-filter",
                        filter: true,
                        display: "chip"
                      }, null, 8, ["modelValue", "onUpdate:modelValue", "onChange", "options"])
                    ]),
                    body: _withCtx((slotProps) => [
                      _createTextVNode(_toDisplayString(_ctx.Gender.byCode(slotProps.data.gender)), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_Column, {
                    field: "status",
                    header: "State",
                    showFilterMenu: false
                  }, {
                    filter: _withCtx(({ filterModel, filterCallback }) => [
                      _createVNode(_component_MultiSelect, {
                        modelValue: filterModel.value,
                        "onUpdate:modelValue": ($event: any) => ((filterModel.value) = $event),
                        onChange: ($event: any) => (filterCallback()),
                        options: _ctx.Status.values,
                        optionLabel: "name",
                        optionValue: "code",
                        placeholder: "Any",
                        class: "p-column-filter",
                        filter: true,
                        display: "chip"
                      }, null, 8, ["modelValue", "onUpdate:modelValue", "onChange", "options"])
                    ]),
                    body: _withCtx((slotProps) => [
                      _createTextVNode(_toDisplayString(_ctx.Status.byCode(slotProps.data.status)), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_Column, { header: "Edit" }, {
                    body: _withCtx((slotProps) => [
                      _createVNode(_component_Button, {
                        icon: "pi pi-pencil",
                        class: "p-button-rounded p-button-text",
                        onClick: ($event: any) => (_ctx.selectPat(slotProps.data))
                      }, null, 8, ["onClick"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_Column, { header: "Recommended Donors" }, {
                    body: _withCtx((slotProps) => [
                      _createVNode(_component_Button, {
                        icon: "pi pi-list",
                        class: "p-button-rounded p-button-text",
                        onClick: ($event: any) => (_ctx.showRecommendedDonors(slotProps.data))
                      }, null, 8, ["onClick"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_Column, {
                    field: "news",
                    header: "Record update",
                    sortable: true
                  }, {
                    body: _withCtx((slotProps) => [
                      (slotProps.data.news)
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 0,
                            title: _ctx.News.byCode(slotProps.data.news)
                          }, [
                            _createVNode(_component_InlineMessage, { severity: "info" })
                          ], 8, _hoisted_9))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["value", "totalRecords", "rows", "rowsPerPageOptions", "filters", "onPage", "onSort", "onFilter", "rowClass"])
            ]),
            _: 1
          }),
          _createVNode(_component_TabPanel, { header: "Patient In Process" }, {
            default: _withCtx(() => [
              _createVNode(_component_DataTable, {
                id: "tablePatientInProcess",
                class: "p-datatable-striped p-datatable-sm",
                value: _ctx.ataPatients,
                lazy: true,
                totalRecords: _ctx.ataPatientsCount,
                paginator: true,
                rows: _ctx.rows,
                paginatorTemplate: "FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink",
                sortMode: "multiple",
                removableSort: "",
                multiSortMeta: _ctx.ataDefSort,
                sortOrder: -1,
                dataKey: "id",
                onPage: _ctx.ataPageEvent,
                onSort: _ctx.ataSortEvent,
                autoLayout: ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_Column, {
                    field: "patientid1",
                    header: "T-number",
                    sortable: true
                  }),
                  _createVNode(_component_Column, {
                    field: "patcenter",
                    header: "TC",
                    sortable: true
                  }),
                  _createVNode(_component_Column, {
                    field: "lastname",
                    header: "Last Name",
                    sortable: true
                  }),
                  _createVNode(_component_Column, {
                    field: "firstname",
                    header: "First Name",
                    sortable: true
                  }),
                  _createVNode(_component_Column, {
                    field: "birthdate",
                    header: "Date of Birth",
                    sortable: true
                  }, {
                    body: _withCtx((slotProps) => [
                      _createTextVNode(_toDisplayString(_ctx.formatDate(slotProps.data.birthdate)), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_Column, {
                    field: "gender",
                    header: "Gender"
                  }, {
                    body: _withCtx((slotProps) => [
                      _createTextVNode(_toDisplayString(_ctx.Gender.byCode(slotProps.data.gender)), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_Column, {
                    field: "status",
                    header: "State"
                  }, {
                    body: _withCtx((slotProps) => [
                      _createTextVNode(_toDisplayString(_ctx.Status.byCode(slotProps.data.status)), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_Column, {
                    field: "createdate",
                    header: "Created",
                    sortable: true
                  }, {
                    body: _withCtx((slotProps) => [
                      _createTextVNode(_toDisplayString(_ctx.formatDate(slotProps.data.createdate, true)), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_Column, { header: "Record update" }, {
                    body: _withCtx((slotProps) => [
                      _createVNode(_component_InlineMessage, {
                        severity: slotProps.data.patientid ? 'warn' : 'info'
                      }, {
                        default: _withCtx(() => [
                          (slotProps.data.patientid)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_10, "Edit"))
                            : (_openBlock(), _createElementBlock("span", _hoisted_11, "New"))
                        ]),
                        _: 2
                      }, 1032, ["severity"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["value", "totalRecords", "rows", "multiSortMeta", "onPage", "onSort"])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}